import announcementIcon from "/public/assets/icons/announcement.svg"
import Typography from "@mui/material/Typography"
import useHeadingStyles from "hooks/useHeadingStyles"
import Image from "next/image"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles()(
  (theme) => ({
    title: {
      display: "flex",
      alignItems: "center",
    },
    announcement: {
      margin: "20px 0 40px 0",
      color: "#262B2D",
      fontFamily: "Lato",
      fontSize: "16px",
      letterSpacing: 0,
      lineHeight: "22px",
      whiteSpace: "pre-wrap",
      [theme.breakpoints.up("md")]: {
        marginRight: "125px",
      },
    },
    icon: {
      color: "#1976D2",
      height: "36px",
      width: "auto",
    },
  })
)

interface IAnnouncement {
  announcement: string
}

const Announcement = (props: IAnnouncement) => {
  const { announcement } = props

  const { classes, cx } = useStyles()

  const { classes: headingClasses } = useHeadingStyles()

  return (
    <>
      <Typography variant="h5" className={cx(headingClasses.h5, classes.title)}>
        <Image src={announcementIcon} className={classes.icon} alt="Announcements Icon" role="presentation" /> Announcements
      </Typography>
      <Typography className={classes.announcement}>{announcement}</Typography>
    </>
  )
}

export default Announcement
